module.exports = "/_next/static/images/gi-4217c0d806ff637b14eb221fadbb31bb.svg";